import { getGroups } from '../../../../store/models/selectors';
import { TRecording, TUserGroup } from '../../../../store/models/types';
import { createSelector } from 'reselect';
import { EUserGroupType } from '../../../../store/general/types';
import { getAuthUser } from '../../../../store/general/selectors';
import { EMPTY_ARRAY } from '../../../../../common/types';
import { IState } from '../../../../store/types';

export const getCallRecordingsSelector = createSelector(
	getGroups,
	(state: IState) => getAuthUser(state)?.id || 0,
	(
		groups: TUserGroup[],
		myId: number,
	): TRecording[] => {
		const allRecordings = groups.reduce((acc: TRecording[], g: TUserGroup) => {
			if (
				g.type !== EUserGroupType.CONFERENCE ||
				!g.audios || !g.audios.length
			) return acc;

			const audios = g.audios.map(a => {
				const recording = a as TRecording;
				return {
					...recording,
					isLoading: !recording.url,
					participants: recording.participants?.filter(p => p.id !== myId) || [],
				};
			}) as TRecording[];

			return [
				...acc,
				...audios,
			];
		}, [])
			.sort((a, b) => b.createdAt.localeCompare(a.createdAt));

		return allRecordings.length ? allRecordings.slice(0, 5) : EMPTY_ARRAY;
	}
);

export const getCallRecordingsAllReadySelector = createSelector(
	getCallRecordingsSelector,
	(recordings: TRecording[]): boolean =>
		recordings.length > 0 && recordings.every(r => !r.isLoading),
);
